import { render, staticRenderFns } from "./NewCustomer.vue?vue&type=template&id=005efef6&scoped=true"
import script from "./NewCustomer.vue?vue&type=script&lang=js"
export * from "./NewCustomer.vue?vue&type=script&lang=js"
import "./NewCustomer.vue?vue&type=style&index=0&id=005efef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005efef6",
  null
  
)

export default component.exports